// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kXWP","question":"styles_question__2LNqJ","inputVisibleButton":"styles_inputVisibleButton__2VItB","note":"styles_note__bh9gF"};